import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sctqzguuyk: FaireBrandEntity = {
  token: "b_sctqzguuyk",
  type: "brand",
  name: "THE DANCING WICK CANDLES",
  avatarUrl:
    "https://cdn.faire.com/fastly/d97381aa26059900136e5e5a5c43a3be0ef934b95e1b9757018932b845f54dce.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/25e5a55c1e97f861336c509f0908683e2a1231fdef53f732c37b47801595509e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d97381aa26059900136e5e5a5c43a3be0ef934b95e1b9757018932b845f54dce.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/25e5a55c1e97f861336c509f0908683e2a1231fdef53f732c37b47801595509e.png",
  location: "Bixby, OK, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 41,
  isTopShop: true,
  isInsider: true,
  description:
    "The Dancing Wick is a family-run candle company built on a simple mission: to create products that make everyday moments feel more meaningful. What started as a small, handmade passion has grown into a trusted brand with tens of thousands of five-star reviews, known for quality, care, and consistency. Every candle is hand-poured in the USA using 100% natural soy wax, cotton wicks, and clean, thoughtfully chosen scents to create a safe, inviting atmosphere in any home. From personalized gifts to meaningful favors and everyday essentials, our products are designed to help people celebrate life’s moments both big and small. At the heart of it all is a commitment to craftsmanship, family values, and creating something special that customers come back to again and again.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:55.993Z",
    importedBy: "entity-db-cli",
  },
};
